
import { useState, useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";

import FormatAccount from "./FormatAccount";


function InputBankAccount(props)
{   
    const [val, setVal] = useState(props.value);    

 

    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);




     
    /*
     * Returns 1 if the IBAN is valid 
     * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
     * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
     */
    function isValidIBANNumber(input) {
        var CODE_LENGTHS = {
            AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
            CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
            FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
            HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
            LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
            MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
            RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,   
            AL: 28, BY: 28, CR: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
            SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
        };
        var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
                code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
                digits;
        // check syntax and length
        if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
            return false;
        }
        // rearrange country code and check digits, and convert chars to ints
        digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
            return letter.charCodeAt(0) - 55;
        });
        // final check
        return mod97(digits) === 1;
    }
    
    function mod97(string) {
        var checksum = string.slice(0, 2), fragment;
        for (var offset = 2; offset < string.length; offset += 7) {
            fragment = String(checksum) + string.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    }
    


    const isValid = (num)  => {

            //https://moneteo.com/artykuly/numer-konta-bankowego-iban

        if ( num.length != 28) return false;

       
        var v = isValidIBANNumber(num);
        
        return v;
    }



    const getNameBank = (num) => {
        
        //bank..
        var banki = [
            {numer: 2490,nazwa: "Alior Bank SA"},
            {numer: 1060,nazwa: "Bank BPH SA"},
            {numer: 2190,nazwa: "Bank DnB NORD Polska SA"},
            {numer: 2030,nazwa: "Bank Gospodarki Żywnościowej SA"},
            {numer: 1130,nazwa: "Bank Gospodarstwa Krajowego"},
            {numer: 1030,nazwa: "Bank Handlowy w Warszawie SA"},
            {numer: 1160,nazwa: "Bank Millennium SA"},
            {numer: 1540,nazwa: "Bank Ochrony Środowiska SA"},
            {numer: 2210,nazwa: "Bank of Tokyo-Mitsubishi UFJ (Polska) SA"},
            {numer: 1320,nazwa: "Bank Pocztowy SA"},
            {numer: 1240,nazwa: "Bank Polska Kasa Opieki SA"},
            {numer: 1930,nazwa: "BANK POLSKIEJ SPÓŁDZIELCZOŚCI SA"},
            {numer: 1090,nazwa: "Bank Zachodni WBK SA"},
            {numer: 1600,nazwa: "BNP PARIBAS BANK POLSKA SA"},
            {numer: 2290,nazwa: "BPI Bank Polskich Inwestycji SA"},
            {numer: 2150,nazwa: "BRE Bank Hipoteczny SA"},
            {numer: 2540,nazwa: "Citibank Europe plc (Publiczna Spółka Akcyjna) Oddział w Polsce"},
            {numer: 1940,nazwa: "Credit Agricole Bank Polska SA"},
            {numer: 1910,nazwa: "Deutsche Bank PBC SA"},
            {numer: 1880,nazwa: "Deutsche Bank Polska SA"},
            {numer: 1740,nazwa: "DZ BANK Polska SA"},
            {numer: 1470,nazwa: "Euro Bank SA"},
            {numer: 2070,nazwa: "FCE Bank Polska SA"},
            {numer: 2140,nazwa: "Fiat Bank Polska SA"},
            {numer: 1870,nazwa: "FM Bank PBP SA"},
            {numer: 2480,nazwa: "Getin Noble Bank SA"},
            {numer: 1280,nazwa: "HSBC Bank Polska SA"},
            {numer: 1950,nazwa: "Idea Bank SA"},
            {numer: 1050,nazwa: "ING Bank Śląski SA"},
            {numer: 1680,nazwa: "INVEST - BANK SA"},
            {numer: 1140,nazwa: "mBank SA"},
            {numer: 1580,nazwa: "Mercedes-Benz Bank Polska SA"},
            {numer: 1300,nazwa: "Meritum Bank ICB SA"},
            {numer: 1010,nazwa: "Narodowy Bank Polski"},
            {numer: 1440,nazwa: "NORDEA BANK POLSKA SA"},
            {numer: 1890,nazwa: "Pekao Bank Hipoteczny SA"},
            {numer: 1020,nazwa: "Powszechna Kasa Oszczędności Bank Polski SA"},
            {numer: 2000,nazwa: "Rabobank Polska SA"},
            {numer: 1750,nazwa: "Raiffeisen Bank Polska SA"},
            {numer: 1670,nazwa: "RBS Bank (Polska) SA"},
            {numer: 2120,nazwa: "Santander Consumer Bank SA"},
            {numer: 1610,nazwa: "SGB-Bank SA"},
            {numer: 2160,nazwa: "Toyota Bank Polska SA"},
            {numer: 2130,nazwa: "VOLKSWAGEN BANK POLSKA SA"},
            {numer: 2510,nazwa: "Aareal Bank Aktiengesellschaft (Spółka Akcyjna) - Oddział w Polsce"},
            {numer: 2470,nazwa: "Banco Espirito Santo de Investimento, S.A. Spółka Akcyjna Oddział w Polsce"},
            {numer: 2380,nazwa: "Banco Mais S.A. (SA) Oddział w Polsce"},
            {numer: 2600,nazwa: "Bank of China (Luxembourg)S.A. Spółka Akcyjna Oddział w Polsce"},
            {numer: 2240,nazwa: "Banque PSA Finance SA Oddział w Polsce"},
            {numer: 2350,nazwa: "BNP PARIBAS SA Oddział w Polsce"},
            {numer: 2430,nazwa: "BNP Paribas Securities Services SKA Oddział w Polsce"},
            {numer: 2390,nazwa: "CAIXABANK, S.A. (SPÓŁKA AKCYJNA)ODDZIAŁ W POLSCE"},
            {numer: 2360,nazwa: "Danske Bank A/S SA Oddział w Polsce"},
            {numer: 2680,nazwa: "DZ BANK AG Deutsche Zentral-Genossenschaftsbank, Frankfurt am Main Spóka Akcyjna Oddział w Polsce"},
            {numer: 2410,nazwa: "Elavon Financial Services Limited (Spółka z ograniczoną odpowiedzialnością) Oddział w Polsce"},
            {numer: 2650,nazwa: "EUROCLEAR Bank SA/NV (Spółka Akcyjna) - Oddział w Polsce"},
            {numer: 2450,nazwa: "HSBC Bank plc (SA) Oddział w Polsce (w organizacji)"},
            {numer: 2550,nazwa: "Ikano Bank GmbH (Sp. z o.o.) Oddział w Polsce"},
            {numer: 2620,nazwa: "Industrial and Commercial Bank of China (Europe) S.A. (Spółka Akcyjna) Oddział w Polsce"},
            {numer: 2660,nazwa: "Intesa Sanpaolo S.p.A. Spółka Akcyjna Oddział w Polsce"},
            {numer: 2580,nazwa: "J.P. Morgan Europe Limited Sp. z o.o. Oddział w Polsce"},
            {numer: 2560,nazwa: "Nordea Bank AB SA Oddział w Polsce"},
            {numer: 2320,nazwa: "Nykredit Realkredit A/S SA - Oddział w Polsce"},
            {numer: 2640,nazwa: "RCI Banque Spółka Akcyjna Oddział w Polsce"},
            {numer: 2630,nazwa: "Saxo Bank A/S Spółka Akcyjna Oddział w Polsce"},
            {numer: 2370,nazwa: "Skandinaviska Enskilda Banken AB (SA) - Oddział w Polsce"},
            {numer: 1840,nazwa: "Societe Generale SA Oddział w Polsce"},
            {numer: 2250,nazwa: "Svenska Handelsbanken AB SA Oddział w Polsce"},
            {numer: 2270,nazwa: "Sygma Banque Societe Anonyme (SA) Oddział w Polsce"},
            {numer: 2300,nazwa: "The Royal Bank of Scotland N.V. SA Oddział w Polsce (w organizacji)"},
            {numer: 2570,nazwa: "UBS Limited (spółka z ograniczoną odpowiedzialnością) Oddział w Polsce"},
            {numer: 2400,nazwa: "UNIBON-Sporitelni a Uverni Druzstvo Spółdzielnia Oszczędnościowa i Kredytowa Oddział w Polsce w likwidacji"},
            {numer: 2610,nazwa: "Vanquis Bank Limited (spółka z ograniczoną odpowiedzialnością) Oddział w Polsce"},
            {numer: 2670,nazwa: "Western Union International Bank GmbH, Sp. z o.o. Oddział w Polsce"},
            {numer: 2590,nazwa: "ZUNO BANK AG SA Oddział w Polsce (w organizacji)"},  
    ];

    var bank = '';

     if(num.length == 26 && isValid('PL' + num) )
     {
        bank = "brak informacji o banku";
        var exp = num.split('');
       
        var num = exp[2] + "" + exp[3]  + "" + exp[4] + "" + exp[5];
        var numer = parseInt(num);

        console.log("Numer banku ", numer);

        for(var k=0; k<banki.length; k++ )
        {
            if(banki[k].numer == numer)
            {
                bank = banki[k].nazwa;
            }
        }

     }
        

     return bank;
    }



    const validate = (vx) => {
        return false;
      };


    

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

        v = v.replace(/[^0-9.]/g, ''); 

        // if(v.length == 0) v = 0;

         console.log("err " , v);
       
        // v = parseInt(v);    
         
        
 


        var correct = isValid( 'PL' + v );

        var bankName = getNameBank(v);

    
        setVal(v);
                 
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct, bankName);
        }else
        {
            console.log('No support for valChange');
        }    

        
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = false;
        

        correct = isValid( 'PL' + val);

      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;
    var bank = '';


    bank = getNameBank(val);



    if(cn == "incorrent" )
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent"  )
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {

        if(val != props.value && props.value.length > 0 ) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct, bank );
    
        }
    })

     


        
 
 
 
    
 
        
       // if(tmp.length == 0) tmp = "";

       
    

        var err = "";
        if(props.err != undefined  &&  props.err != null ) 
        {       
            if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
        }    
        
        
        var cnX = cn;
        if(val != null && val != undefined &&  val.length < 1 && cnX == 'corrent')
            {
                cnX = '';
            }

       



            
    return <fieldset>        
        <input type="text"  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={" w400  " + cnX} />        
        {imgx}
        <br/>
        <span>{bank}</span>
        <span className="form_err">{err + " "} &nbsp; </span>
    </fieldset>
}


export default InputBankAccount;